import React from 'react';
import { LLink, useLang } from '../i18n';
import { services } from '../content/projects';
import { Laptop, Phone } from './Devices';
import { Arrow } from './motion';

// Still preview of a project: its handover capture in device frames, or the
// brand thumbnail until the project has been captured.
export function ProjectVisual({ project, size = 'md' }) {
  const { capture, name, thumbnail } = project;
  const frame = size === 'lg' ? 'aspect-[4/3] md:aspect-[2/1]' : 'aspect-[4/3]';
  if (capture) {
    return (
      <div className={`flex items-center justify-center bg-cream-soft px-[8%] pt-[6%] ${frame}`}>
        <div className={`relative w-full pe-[10%] ${size === 'lg' ? 'max-w-3xl' : ''}`}>
          <Laptop src={capture.desktop} preview={capture.previewDesktop} alt={name} scrollable={false} />
          <Phone
            src={capture.mobile}
            preview={capture.previewMobile}
            alt=""
            scrollable={false}
            className="absolute -bottom-[4%] end-0 w-[20%] min-w-[56px]"
          />
        </div>
      </div>
    );
  }
  return (
    <div className={`flex items-center justify-center bg-cream-soft p-[10%] ${frame}`}>
      <img
        src={thumbnail}
        width={800}
        height={800}
        alt={name}
        loading="lazy"
        decoding="async"
        className={`aspect-square h-full rounded-2xl object-cover shadow-[0_20px_40px_-24px_rgba(11,11,11,0.35)] ${size === 'lg' ? 'max-h-[22rem]' : ''}`}
      />
    </div>
  );
}

export default function ProjectCard({ project, size = 'md' }) {
  const { t } = useLang();
  return (
    <LLink to={`/work/${project.slug}`} className="group block">
      <div className="overflow-hidden rounded-4xl transition-transform duration-500 ease-[cubic-bezier(0.2,0.8,0.2,1)] group-hover:scale-[0.985] group-active:scale-[0.97]">
        <ProjectVisual project={project} size={size} />
      </div>
      <div className="mt-5 flex items-start justify-between gap-6">
        <div>
          <h3 className="t-h3">{project.name}</h3>
          <p className="mt-1 text-sm text-muted">
            {t(project.industry)} · {project.services.map((s) => t(services[s])).join(', ')}
          </p>
          <p className="mt-3 max-w-md text-[0.9375rem] text-ink-soft">{t(project.summary)}</p>
        </div>
        <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cream-soft transition-colors group-hover:bg-ink group-hover:text-white">
          <Arrow className="h-4 w-4 rtl:-scale-x-100" />
        </span>
      </div>
    </LLink>
  );
}
